import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import React from "react";

export const Locker = () => (
  <span className="svg-icon svg-icon-md svg-icon-light mr-1">
    <SVG src={toAbsoluteUrl("/media/svg/icons/General/Unlock.svg")} />
  </span>
);
